import { G_SCALE_COLORS } from './dstGScale';

// NOAA Kp thresholds at the start of each geomagnetic storm level.
export const KP_G_SCALE_LEVELS = [
  { level: 1, label: 'G1', value: 5, minBound: 5, maxBound: 6, color: G_SCALE_COLORS[1], valueSuffix: '' },
  { level: 2, label: 'G2', value: 6, minBound: 6, maxBound: 7, color: G_SCALE_COLORS[2], valueSuffix: '' },
  { level: 3, label: 'G3', value: 7, minBound: 7, maxBound: 8, color: G_SCALE_COLORS[3], valueSuffix: '' },
  { level: 4, label: 'G4', value: 8, minBound: 8, maxBound: 9, color: G_SCALE_COLORS[4], valueSuffix: '' },
  { level: 5, label: 'G5', value: 9, minBound: 9, maxBound: Infinity, color: G_SCALE_COLORS[5], valueSuffix: '' },
];
